import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { validationSchema, initialValues } from "./cartaPorteConfig.js";

import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import Loader from "../../../../components/loader/index.js";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Swal from "sweetalert2";
import axiosClient from "../../../../config/axios.js";

import {
  findFiscalRegimesByCoincidence,
  findCFDIByCoincidence,
  findPaymentFormByCoincidence,
  getFoliosBySocialReason,
  getSeriesBySocialReason,
  findCustomerSocialReasonByCoincidence,
  findPaymentMethodByCoincidence,
  getMySocialReasons,
} from "../../../../services/CatalogService";

import {
  findPermissionTypesByCoincidence,
  findAutotransportConfigByCoincidence,
  findColoniasByCoincidence,
  findMunicipalitiesByState,
  findPostalCode,
  findColoniasByPostal,
  findStates,
  findClaveProdServCP,
  createCartaPorte,
  getStampFileCartaPorte,
} from "../../../../services/CartaPorteService";

import moment from "moment-timezone";

import CartaPorteFormFields from "./cartaPorteFormFields.js";
import UbicacionFormFields from "./UbicacionFormFields.js";
import MercanciasFormFields from "./mercanciasFormFields.js";
import AutotransporteFormFields from "./autotransporteFormFields.js";
import TableConceptsCartaPorte from "./tableConceptsCartaPorte.js";
import FiguraOperadorFormFields from "./figuraOperatorFormFields.js";
import NewCustomerCartaPorte from "./newCustomerCartaPorte.js";
import DatatableStampedCartaPorte from "./datatableStampedCartaPorte.js";

import { FormikProvider } from "formik";
import { XMLParser } from 'fast-xml-parser';

function AddCartaPorteForm() {
  const razonSocialAPI = "GruasVaro";
  const navigate = useNavigate();

  const [razonSocial, setRazonSocial] = useState([""]);
  const [orden, setOrden] = useState(null); // datos de la orden
  const { id } = useParams();

  const [folios, setFolios] = useState([]);
  const [series, setSeries] = useState([]);

  const [conceptoFactura, setconceptoFactura] = useState("");
  const [fecha, setFecha] = useState("");
  const [pagosContado, setPagosContado] = useState([]);
  const [pagosCredito, setPagosCredito] = useState([]);
  const [selectedProductKey, setSelectedProductKey] = useState(null);
  const [insurers, setInsurers] = useState([]);
  const [showNewCustomerForm, setShowNewCustomerForm] = useState(false);
  const [showCartaPorteForm, setShowCartaPorteForm] = useState(true);

  const [loading, setLoading] = useState(true);
  const [lastCartaPorte, setLastCartaPorte] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0); 
  
  useEffect(() => {
    const fetchLastCartaPorte = async () => {
      try {
        const response = await axiosClient.get(
          `/stamped-carta-portes/last-by-order/${id}`
        );
        if (response?.data?.data) {
          setLastCartaPorte(response.data.data);
        }
      } catch (err) {
        console.error("Error al obtener carta porte:", err);
      }
    };

    if (id) {
      fetchLastCartaPorte();
    }
  }, [id]);

  const handleDownloadCartaPorte = async () => {
    try {
      const fileResponse = await getStampFileCartaPorte(
        lastCartaPorte.uuid_stamp,
        razonSocialAPI
      );

      if (fileResponse?.file?.url) {
        const link = document.createElement("a");
        link.href = fileResponse.file.url;
        link.setAttribute(
          "download",
          `${fileResponse.file.name || "CartaPorte"}.${
            fileResponse.file.extension || "pdf"
          }`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        Swal.fire(
          "Ups!",
          "No se pudo obtener el archivo de la Carta Porte",
          "error"
        );
      }
    } catch (err) {
      Swal.fire("Error", "No se pudo descargar la Carta Porte", "error");
    }
  };

  const buildCfdiObject = (values) => {
    // Genera el IdCCP con prefijo CCC
    const idCCP = "CCC" + crypto.randomUUID().slice(3);

    return {
      Version: "4.0",
      Moneda: "MXN",
      Fecha: fecha + "T00:00:00",
      Serie: values.serie,
      Folio: values.folio,
      TipoDeComprobante: "I", // ingreso
      Exportacion: "01", // no aplica exportación
      FormaPago: values.paymentMethodId.id,
      MetodoPago: values.paymentFormId.id,
      LugarExpedicion: values.customerId.socialReason.postalCode,
      lada:  values.customerId.lada_phone,
      phone:  values.customerId.phone,
      Receptor: {
        Rfc: values.customerId.rfc,
        Nombre: values.customerId.name,
        DomicilioFiscalReceptor: values.customerId.postalCode,
        RegimenFiscalReceptor: values.fiscalRegimeId?.id ?? "",
        UsoCFDI: values.cfdiId.id,
      },
      ObjetoImp: "02",
      Conceptos: values.conceptosFacturaTabla.map((c) => {
        const precioSinIva = parseFloat(c.precioUnitario) || 0;
        const cantidad = parseFloat(c.cantidad) || 0;
  
        const valorUnitarioConIva = precioSinIva * 1.16;
        const importeConIva = valorUnitarioConIva * cantidad;
  
        return {
          ClaveProdServ: c.productKey.productKey_idKey,
          Cantidad: cantidad.toString(),
          ClaveUnidad: c.unitKey.unitKey_idKey,
          Unidad: "Servicio",
          Descripcion: c.Descripcion,
          needRetention: c.needRetention,
  
          ValorUnitario: valorUnitarioConIva.toFixed(2),
          Importe: importeConIva.toFixed(2),
  
          Descuento: "0.00",
          ObjetoImp: "02",
        };
      }),
      Complemento: {
        Any: [
          {
            "cartaporte31:CartaPorte": {
              Version: "3.1",
              IdCCP: idCCP,
              TranspInternac: "No",
              TotalDistRec: values.DistanciaRecorrida.toString(),
              Ubicaciones: [
                {
                  TipoUbicacion: "Origen",
                  IDUbicacion: "OR000001",
                  RFCRemitenteDestinatario: values.customerId.socialReason.rfc, //remitente
                  NombreRemitenteDestinatario:
                    values.customerId.socialReason.name,
                  FechaHoraSalidaLlegada: values.fechaHoraSalidaOrigen,
                  Domicilio: {
                    Calle: values.calleOrigen,
                    Colonia: values.coloniaOrigen.c_Colonia,
                    Municipio: values.municipioOrigen.c_Municipio,
                    Estado: values.estadoOrigen.id,
                    Pais: values.paisOrigen,
                    CodigoPostal: values.codigoPostalOrigen.id,
                  },
                },
                {
                  TipoUbicacion: "Destino",
                  IDUbicacion: "DE000001",
                  RFCRemitenteDestinatario: values.customerId.rfc, //destinatario
                  NombreRemitenteDestinatario: values.customerId.name,
                  FechaHoraSalidaLlegada: values.fechaHoraLlegadaDestino,
                  DistanciaRecorrida: values.DistanciaRecorrida.toString(),
                  Domicilio: {
                    Calle: values.calleDestino,
                    Colonia: values.coloniaDestino.c_Colonia,
                    Municipio: values.municipioDestino.c_Municipio,
                    Estado: values.estadoDestino.id,
                    Pais: values.paisDestino,
                    CodigoPostal: values.codigoPostalDestino.id,
                  },
                },
              ],
              Mercancias: {
                PesoBrutoTotal: values.mercancias.PesoBrutoTotal,
                UnidadPeso: values.mercancias.UnidadPeso,
                NumTotalMercancias: values.mercancias.NumTotalMercancias,
                Mercancia: values.mercancias.Mercancia.map((m) => ({
                  BienesTransp: m.BienesTransp.id,
                  Descripcion: m.Descripcion,
                  Cantidad: m.Cantidad.toString(),
                  ClaveUnidad: m.ClaveUnidad,
                  PesoEnKg: m.PesoEnKg.toString(),
                  CantidadTransporta: m.CantidadTransporta.map((ct) => ({
                    Cantidad: ct.Cantidad.toString(),
                    IDOrigen: ct.IDOrigen,
                    IDDestino: ct.IDDestino,
                  })),
                })),
                Autotransporte: {
                  PermSCT: values.PermSCT.id,
                  NumPermisoSCT: values.NumPermisoSCT,
                  IdentificacionVehicular: {
                    ConfigVehicular: values.ConfigVehicular.id,
                    PesoBrutoVehicular: values.PesoBrutoVehicular,
                    PlacaVM: values.PlacaVM,
                    AnioModeloVM: values.AnioModeloVM.toString(),
                  },
                  Seguros: {
                    AseguraRespCivil: values.AseguraRespCivil.label,
                    PolizaRespCivil: values.PolizaRespCivil,
                  },
                  //Remolques: [], // si no hay, se manda vacío
                },
              },
              FiguraTransporte: [
                {
                  TipoFigura: values.TipoFigura,
                  NombreFigura: values.NombreFigura,
                  RFCFigura: values.RFCFigura,
                  NumLicencia: values.NumLicencia,
                },
              ],
            },
          },
        ],
      },
    };
  };

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: validationSchema,
    initialValues: initialValues,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(false);
      try {
        // lógica para guardar
        const confirmResult = await Swal.fire({
          title: "¿Estás seguro?",
          text: "¿Deseas realizar la carta porte de esta orden?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, realizar carta porte",
          cancelButtonText: "Cancelar",
        });

        if (!confirmResult.isConfirmed) {
          setSubmitting(false);
          return;
        }
        setSubmitting(true);

        console.log("Valores enviados:", values);
        const cfdiObject = buildCfdiObject(values);

        const data = await createCartaPorte(cfdiObject, razonSocialAPI);
        console.log("datos de carta porte", data);

        // Función para limpiar
        const cleanNumber = (value) => {
          if (!value) return 0;
          const cleaned = value.toString().replace(/[^0-9.-]+/g, "");
          return cleaned === "" ? 0 : Number(cleaned);
        };

        // Parsear XML del cfdi
        const parser = new XMLParser({
          ignoreAttributes: false,
          attributeNamePrefix: "@_",
        });

        const cfdiXml = data.cfdi.cfdi;
        const cfdiParsed = parser.parse(cfdiXml);

        // El comprobante principal
        const comprobante = cfdiParsed["cfdi:Comprobante"];

        // Subtotal y total
        const cleanSubtotal = cleanNumber(comprobante["@_SubTotal"]);
        const cleanTotal = cleanNumber(comprobante["@_Total"]);

        // Impuestos
        const impuestos = comprobante["cfdi:Impuestos"] || {};
        const traslados = impuestos["cfdi:Traslados"]?.["cfdi:Traslado"];
        const trasladoIVA = Array.isArray(traslados) ? traslados[0] : traslados || {};

        // IVA total
        const cleanIva = cleanNumber(
          impuestos["@_TotalImpuestosTrasladados"] || trasladoIVA["@_Importe"] || 0
        );

        const retencion = cleanNumber(
          impuestos["@_TotalImpuestosRetenidos"] || 0
        );

        // Payload final
        const stampedCartaPortePayload = {
          customer_name: cfdiObject.Receptor.Nombre || "SIN NOMBRE",
          customer_rfc: cfdiObject.Receptor.Rfc || "XAXX010101000",
          issued_at: moment.utc().format(),
          order_id: id,
          id_facturacion_cartaPorte: data.id,
          uuid_stamp: data.cfdi.uuid,
          status: data.cfdi.status || "vigente",

          total: cleanTotal,
          subtotal: cleanSubtotal,
          iva: cleanIva,
          retencion: retencion,
        };


        console.log("Payload que se enviará:", stampedCartaPortePayload);

        await axiosClient.post(
          "/stamped-carta-porte/save",
          stampedCartaPortePayload
        );

        setLastCartaPorte(stampedCartaPortePayload);
        setRefreshKey((oldKey) => oldKey + 1);
        //}

        Swal.fire({
          title: "¡Éxito!",
          text: "Carta Porte creada correctamente",
          icon: "success",
          confirmButtonText: "Aceptar",
        });

        console.log("Objeto a enviar cartaporte:", cfdiObject);
      } catch (err) {
        const errorData = err.response?.data;
        const errorMessage = Array.isArray(errorData?.message)
          ? errorData.message.join(", ")
          : errorData?.message ||
            errorData?.error ||
            "Ha ocurrido un error inesperado";

        Swal.fire({
          title: "Ups!",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "Cerrar",
          showCancelButton: false,
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const localDate = moment.tz("America/Mexico_City").format("YYYY-MM-DD");
    setFecha(localDate);
    formik.setFieldValue("fecha", localDate);

    const fetchOrder = async () => {
      try {
        setLoading(true);

        // Obtener orden
        const { data: ordenData } = await axiosClient.get(`/orders/${id}`);
        setOrden(ordenData);
        console.log("Datos orden:", ordenData);

        // Obtener aseguradoras
        const resInsurers = await axiosClient.get(`/insurers/all`);
        const insurersOptions = resInsurers.data.data.map((item) => ({
          value: item.id,
          label: item.insurance_name,
        }));
        setInsurers(insurersOptions);

        // Buscar la ubicación de origen
        const ubicacionOrigen = ordenData?.OrderLocations?.find(
          (loc) => loc.index === 0
        );

        if (ubicacionOrigen) {
          // Buscamos y seteamos en Formik
          formik.setFieldValue("paisOrigen", ubicacionOrigen.pais || "MEX");
          formik.setFieldValue("calleOrigen", ubicacionOrigen.calle || "");

          // Buscar código postal
          if (ubicacionOrigen.codigo_postal) {
            const codigosPostales = await findPostalCode(
              ubicacionOrigen.codigo_postal
            );
            if (codigosPostales.length) {
              formik.setFieldValue("codigoPostalOrigen", codigosPostales[0]);
            }
          }
          // Inicializar Estado
          if (ubicacionOrigen.estado_clave) {
            const estados = await findStates(ubicacionOrigen.estado_clave);
            if (estados.length) {
              formik.setFieldValue("estadoOrigen", estados[0]);
            }
          }
          // Buscar municipio según estado
          if (ubicacionOrigen.municipio && ubicacionOrigen.estado_clave) {
            const municipios = await findMunicipalitiesByState(
              ubicacionOrigen.estado_clave,
              ubicacionOrigen.municipio
            );
            if (municipios.length) {
              formik.setFieldValue("municipioOrigen", municipios[0]);
            }
          }
          // Buscar colonias según código postal y nombre
          if (ubicacionOrigen.colonia && ubicacionOrigen.codigo_postal) {
            const colonias = await findColoniasByPostal(
              ubicacionOrigen.codigo_postal,
              ubicacionOrigen.colonia
            );
            if (colonias.length) {
              formik.setFieldValue("coloniaOrigen", colonias[0]);
            }
          }
        }

        // Buscar la ubicación de destino
        const ubicacionDestino = ordenData?.OrderLocations?.find(
          (loc) => loc.index === 1
        );

        if (ubicacionDestino) {
          // Buscamos y seteamos en Formik
          formik.setFieldValue("paisDestino", ubicacionDestino.pais || "MEX");
          formik.setFieldValue("calleDestino", ubicacionDestino.calle || "");
          formik.setFieldValue(
            "DistanciaRecorrida",
            ordenData?.total_distance || ""
          );

          // Buscar código postal
          if (ubicacionDestino.codigo_postal) {
            const codigosPostales = await findPostalCode(
              ubicacionDestino.codigo_postal
            );
            if (codigosPostales.length) {
              formik.setFieldValue("codigoPostalDestino", codigosPostales[0]);
            }
          }
          // Inicializar Estado
          if (ubicacionDestino.estado_clave) {
            const estados = await findStates(ubicacionDestino.estado_clave);
            if (estados.length) {
              formik.setFieldValue("estadoDestino", estados[0]);
            }
          }
          // Buscar municipio según estado
          if (ubicacionDestino.municipio && ubicacionDestino.estado_clave) {
            const municipios = await findMunicipalitiesByState(
              ubicacionDestino.estado_clave,
              ubicacionDestino.municipio
            );
            if (municipios.length) {
              formik.setFieldValue("municipioDestino", municipios[0]);
            }
          }
          // Buscar colonias según código postal y nombre
          if (ubicacionDestino.colonia && ubicacionDestino.codigo_postal) {
            const colonias = await findColoniasByPostal(
              ubicacionDestino.codigo_postal,
              ubicacionDestino.colonia
            );
            if (colonias.length) {
              formik.setFieldValue("coloniaDestino", colonias[0]);
            }
          }
        }

        // Autotransporte
        if (ordenData?.Crane) {
          const crane = ordenData.Crane;

          // Permiso SCT (autocomplete)
          if (crane.sct_permit) {
            const permisos = await findPermissionTypesByCoincidence(
              crane.sct_permit
            );
            if (permisos.length) {
              formik.setFieldValue("PermSCT", permisos[0]);
            }
          }

          // Número de permiso SCT
          formik.setFieldValue("NumPermisoSCT", crane.sct_permit_number || "");

          // Configuración vehicular (autocomplete)
          if (crane.vehicular_config) {
            const configs = await findAutotransportConfigByCoincidence(
              crane.vehicular_config
            );
            if (configs.length) {
              formik.setFieldValue("ConfigVehicular", configs[0]);
            }
          }

          // Peso bruto vehicular
          formik.setFieldValue(
            "PesoBrutoVehicular",
            crane.gross_vehicle_weight || ""
          );

          // Placa del vehículo
          formik.setFieldValue("PlacaVM", crane.plate || "");

          // Año modelo
          formik.setFieldValue("AnioModeloVM", crane.year || "");

          // Aseguradora RC (select)
          if (crane.insurance_id) {
            const aseguradoraSeleccionada = insurersOptions.find(
              (opt) => opt.value === crane.insurance_id
            );
            if (aseguradoraSeleccionada) {
              formik.setFieldValue("AseguraRespCivil", aseguradoraSeleccionada);
            }
          }

          // Póliza de RC
          formik.setFieldValue(
            "PolizaRespCivil",
            crane.civil_liability_policy || ""
          );
        }

        // Inicializar operador (tomar solo el primero)
        const operador = ordenData?.OrderOperators?.[0]?.User;
        if (operador) {
          formik.setFieldValue("TipoFigura", operador.figure_type || "");
          formik.setFieldValue(
            "NombreFigura",
            `${operador.name || ""} ${operador.first_surname || ""} ${
              operador.second_surname || ""
            }`.trim()
          );
          formik.setFieldValue("RFCFigura", operador.figure_rfc || "");
          formik.setFieldValue("NumLicencia", operador.license_number || "");
        }

        // Obtener pagos activos (contado y crédito)
        const [contadoRes, creditoRes] = await Promise.all([
          axiosClient.get(
            `/payments/activePaymentsByOrder/${id}?only_active_payments=true&payment_type_code=CONTADO`
          ),
          axiosClient.get(
            `/payments/activePaymentsByOrder/${id}?only_active_payments=true&payment_type_code=CREDITO`
          ),
        ]);

        setPagosContado(contadoRes.data || []);
        setPagosCredito(creditoRes.data || []);

        // console.log("Pagos contado:", contadoRes.data);
        // console.log("Pagos crédito:", creditoRes.data);
      } catch (error) {
        Swal.fire("Error", "No se pudo cargar la orden o los pagos", "error");
      } finally {
        setLoading(false);
      }
    };

    // Cargar folios, series y razones sociales
    const loadCatalogs = async () => {
      const rs = await getMySocialReasons(razonSocialAPI);
      setRazonSocial(rs);

      const foliosData = await getFoliosBySocialReason(razonSocialAPI);
      setFolios(foliosData);

      const seriesData = await getSeriesBySocialReason(razonSocialAPI);
      setSeries(seriesData);
    };

    fetchOrder();
    loadCatalogs();
  }, []);

  useEffect(() => {
    const customer = formik.values.customerId;

    const setCfdiAndRegime = async () => {
      if (customer && customer.cfdi && customer.fiscalRegime) {
        try {
          // Buscar CFDI por ID
          const cfdiResults = await findCFDIByCoincidence(customer.cfdi.id);
          if (cfdiResults?.length) {
            formik.setFieldValue("cfdiId", cfdiResults[0], true);
          } else {
            formik.setFieldValue("cfdiId", null, true);
          }

          // Buscar Régimen Fiscal por ID
          const regimeResults = await findFiscalRegimesByCoincidence(
            customer.fiscalRegime.id
          );
          if (regimeResults?.length) {
            formik.setFieldValue("fiscalRegimeId", regimeResults[0], true);
          } else {
            formik.setFieldValue("fiscalRegimeId", null, true);
          }
        } catch (error) {
          console.error("Error buscando cfdi/regimen:", error);
          formik.setFieldValue("cfdiId", null, true);
          formik.setFieldValue("fiscalRegimeId", null, true);
        }
      } else {
        formik.setFieldValue("cfdiId", null, true);
        formik.setFieldValue("fiscalRegimeId", null, true);
      }
    };

    setCfdiAndRegime();
  }, [formik.values.customerId]);

  const handleNewCustomerClick = () => {
    setShowCartaPorteForm(false);
    setShowNewCustomerForm(true);
  };

  if (loading || !initialValues) return <Loader isLoading={true} />;

  if (showNewCustomerForm) {
    return (
      <NewCustomerCartaPorte
        onBack={(newCustomer) => {
          setShowNewCustomerForm(false);

          if (newCustomer) {
            formik.setFieldValue("customerId", newCustomer);
          }
        }}
      />
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/facturacion-ordenes">Facturación de órdenes</Link>
            </li>
            <li className="breadcrumb-item active">Nueva Carta Porte</li>
          </ol>
          <h1 className="page-header mb-0">
            Registro de nueva Carta Porte - Folio{" "}
            {orden.folio.toString().padStart(5, "0")}
          </h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Form noValidate onSubmit={formik.handleSubmit}>
            <Loader isLoading={formik.isSubmitting} />

            <Panel>
              <PanelHeader>Registro de nueva Carta Porte</PanelHeader>
              <PanelBody>
                <CartaPorteFormFields
                  formik={formik}
                  razonSocialAPI={razonSocialAPI}
                  conceptoFactura={conceptoFactura}
                  setconceptoFactura={setconceptoFactura}
                  fecha={fecha}
                  setFecha={setFecha}
                  folios={folios}
                  series={series}
                  razonSocial={razonSocial}
                  setCustomerId={(value) =>
                    formik.setFieldValue("customerId", value)
                  }
                  findPaymentFormByCoincidence={findPaymentFormByCoincidence}
                  findPaymentMethodByCoincidence={
                    findPaymentMethodByCoincidence
                  }
                  findCustomerSocialReasonByCoincidence={
                    findCustomerSocialReasonByCoincidence
                  }
                  findCFDIByCoincidence={findCFDIByCoincidence}
                  findFiscalRegimesByCoincidence={
                    findFiscalRegimesByCoincidence
                  }
                  onNewCustomerClick={handleNewCustomerClick}
                />
              </PanelBody>
            </Panel>
            <Panel>
              <PanelHeader noButton>Conceptos</PanelHeader>
              <PanelBody>
                <FormikProvider value={formik}>
                  <div className="my-4">
                    <div className="mb-3">
                      <TableConceptsCartaPorte
                        formik={formik}
                        selectedProductKey={selectedProductKey}
                        setSelectedProductKey={setSelectedProductKey}
                        orden={orden}
                      />
                    </div>
                  </div>
                </FormikProvider>
              </PanelBody>
            </Panel>
            <Panel>
              <PanelHeader noButton>Ubicaciones</PanelHeader>
              <PanelBody>
                <div className="my-4">
                  <div className="mb-3">
                    <UbicacionFormFields
                      formik={formik}
                      findColoniasByPostal={findColoniasByPostal}
                      findMunicipalitiesByState={findMunicipalitiesByState}
                      findPostalCode={findPostalCode}
                      findStates={findStates}
                      prefix="origen"
                    />
                  </div>
                </div>
              </PanelBody>
            </Panel>

            <Panel>
              <PanelHeader noButton>Mercancias</PanelHeader>
              <PanelBody>
                <div className="my-4">
                  <div className="mb-3">
                    <MercanciasFormFields
                      formik={formik}
                      findClaveProdServCP={findClaveProdServCP}
                      order={orden}
                    />
                  </div>
                </div>
              </PanelBody>
            </Panel>

            <Panel>
              <PanelHeader noButton>Autotransporte</PanelHeader>
              <PanelBody>
                <div className="my-4">
                  <div className="mb-3">
                    <AutotransporteFormFields
                      formik={formik}
                      findPermissionTypesByCoincidence={
                        findPermissionTypesByCoincidence
                      }
                      findAutotransportConfigByCoincidence={
                        findAutotransportConfigByCoincidence
                      }
                      order={orden}
                      insurers={insurers}
                    />
                  </div>
                </div>
              </PanelBody>
            </Panel>
            <Panel>
              <PanelHeader noButton>Figura Transporte (Operador)</PanelHeader>
              <PanelBody>
                <div className="my-4">
                  <div className="mb-3">
                    <FiguraOperadorFormFields formik={formik} order={orden} />
                  </div>
                </div>
              </PanelBody>
            </Panel>

            {/* <Row className="mb-3">
              <Col md="12" className="d-flex justify-content-end gap-2">
                {!lastCartaPorte ? (
                  <Button type="submit" disabled={formik.isSubmitting}>
                    Guardar
                  </Button>
                ) : (
                  <Button type="button" onClick={handleDownloadCartaPorte}>
                    Descargar Carta Porte previamente creada
                  </Button>
                )}

                <Link to="/facturacion-ordenes" className="btn btn-info">
                  Cancelar
                </Link>
              </Col>
            </Row> */}
            <Row className="mb-3">
              <Col md="12" className="d-flex justify-content-end gap-2">
                {/* {lastCartaPorte && (
                  <Button type="button" onClick={handleDownloadCartaPorte}>
                    Descargar Carta Porte previamente creada
                  </Button>
                )} */}
                <Button type="submit" disabled={formik.isSubmitting}>
                  Guardar
                </Button>

                <Link to="/facturacion-ordenes" className="btn btn-info">
                  Cancelar
                </Link>
              </Col>
            </Row>
          </Form>
        </div>
        <Panel>
          <PanelHeader>Registro de Carta Portes</PanelHeader>
          <PanelBody>
            <Row>
              <Col md="12">
                <h3>
                  <i className="fa-solid fa-file-invoice"></i> Carta portes de
                  la orden{" "}
                </h3>
              </Col>
            </Row>
            <DatatableStampedCartaPorte
              razonSocialFacturacion={razonSocialAPI}
              refreshKey={refreshKey}
            />
          </PanelBody>
        </Panel>
      </div>
    </div>
  );
}

export default AddCartaPorteForm;
